// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tTKR","colMin":"styles_colMin__4bLyp"};